import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    gap: spacing.xxs / 2,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.xs,
  },
  chainRow: {
    justifyContent: 'flex-end',
    marginBottom: 1,
  },
  feesRow: {
    opacity: 0.7,
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xxs / 2,
  },
  tooltipRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: spacing.xxs * 1.5,
    gap: spacing.s,
  },
}));
